//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscBolt(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 22C14.6522 22 17.1957 20.9464 19.071 19.071C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.80432 19.071 4.92896C17.1957 3.05359 14.6522 2 12 2C9.34784 2 6.80432 3.05359 4.92896 4.92896C3.05359 6.80432 2 9.34784 2 12C2 14.6522 3.05359 17.1957 4.92896 19.071C6.80432 20.9464 9.34784 22 12 22ZM16.87 11L11 18V13H7.13L13 6V11H16.87Z" fill="currentColor" /></svg>;
}
export default IconMiscBolt;